import { urlService } from '@/shared/services/UrlService';
import { AxiosResponse, default as axios } from 'axios';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import {
    IAggregateResultHypermediaRepresentation,
    IAggregateResultItemHypermediaRepresentation
} from '../shared/contracts/AggregateContract';
import { IConsultantBarometerKPIResult } from '../shared/contracts/KPIContract';
import { IRootHypermediaRepresentation } from '../shared/contracts/RootContract';
import { IAggregateState, IRootState } from './contract';

const exportState: IAggregateState = {
    allAggregateItem: undefined,
    recentAggregateItem: undefined,
    tribesAggregate: undefined,
    hivesAggregate: undefined,
    hiveAggregate: undefined,
    sectorsAggregate: undefined,
    accountsAggregate: undefined
};

const mutations: MutationTree<IAggregateState> = {
    allAggregateLoaded(state, payload: IAggregateResultItemHypermediaRepresentation) {
        state.allAggregateItem = payload;
    },
    recentAggregateLoaded(state, payload: IAggregateResultItemHypermediaRepresentation) {
        state.recentAggregateItem = payload;
    },
    tribesAggregateLoaded(state, payload: IAggregateResultHypermediaRepresentation) {
        state.tribesAggregate = payload;
    },
    hivesAggregateLoaded(state, payload: IAggregateResultHypermediaRepresentation) {
        state.hivesAggregate = payload;
    },
    hiveAggregateLoaded(state, payload: IAggregateResultHypermediaRepresentation) {
        state.hiveAggregate = payload;
    },
    sectorsAggregateLoaded(state, payload: IAggregateResultHypermediaRepresentation) {
        state.sectorsAggregate = payload;
    },
    accountsAggregateLoaded(state, payload: IAggregateResultHypermediaRepresentation) {
        state.accountsAggregate = payload;
    }
};

const actions: ActionTree<IAggregateState, IRootState> = {
    async fetchAllAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_all.href;
        let response: AxiosResponse<IConsultantBarometerKPIResult> = await axios.get(url);
        commit('allAggregateLoaded', response && response.data);
    },
    async fetchRecentAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_recent.href;
        let response: AxiosResponse<IConsultantBarometerKPIResult> = await axios.get(url);
        commit('recentAggregateLoaded', response && response.data);
    },
    async fetchHivesAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_hives.href;
        let response: AxiosResponse<IAggregateResultHypermediaRepresentation> = await axios.get(url);
        commit('hivesAggregateLoaded', response && response.data);
    },
    async fetchHiveAggregate({ commit, rootState }, hiveId: string): Promise<void> {
        let url = urlService.replaceURIPlaceholders(
            (rootState.root as IRootHypermediaRepresentation)._links.aggregate_hive.href,
            { hiveId }
        );
        let response: AxiosResponse<IAggregateResultHypermediaRepresentation> = await axios.get(url);
        commit('hiveAggregateLoaded', response && response.data);
    },
    async fetchTribesAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_tribes.href;
        let response: AxiosResponse<IAggregateResultHypermediaRepresentation> = await axios.get(url);
        commit('tribesAggregateLoaded', response && response.data);
    },
    async fetchSectorsAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_sectors.href;
        let response: AxiosResponse<IAggregateResultHypermediaRepresentation> = await axios.get(url);
        commit('sectorsAggregateLoaded', response && response.data);
    },
    async fetchAccountsAggregate({ commit, rootState }): Promise<void> {
        let url = (rootState.root as IRootHypermediaRepresentation)._links.aggregate_accounts.href;
        let response: AxiosResponse<IAggregateResultHypermediaRepresentation> = await axios.get(url);
        commit('accountsAggregateLoaded', response && response.data);
    }
};

const getters: GetterTree<IAggregateState, IRootState> = {};

const namespaced: boolean = true;

export const aggregate: Module<IAggregateState, IRootState> = {
    namespaced,
    state: exportState,
    getters,
    actions,
    mutations
};
